// eslint-disable-next-line no-unused-vars
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setStationData } from '../../redux/station-data/station-data.actions';
import { selectStationDataUrl } from '../../redux/station-data/station-data.selectors';
import { enrichData, filterArrayByProperty } from '../../redux/station-data/station-data.utils';

import { setAlertMessage, setOverlayIsVisible, setReloadStaticData } from '../../redux/user/user.actions';

const DataFeed = ({ stationDataUrl, setStationDataFeed, setAlertMessage, setOverlayIsVisible,  setReloadStaticData }) => {

  useEffect( () => {
    // Make the request for the station data
    if (stationDataUrl !== "") {
      setOverlayIsVisible(true);
      makeFeedRequest(stationDataUrl);
    }
  }, [stationDataUrl]);

  function makeFeedRequest(url) {
    let modifiedData = [];

    getDataFeed(url)
    .then( (data) => {
      // Update the data with some new values and then save the data in the REDUX store

      // Remove any data (station) that doesn't have any longitude (and also probably no latitude) coordinates
      modifiedData = filterArrayByProperty(data, "Longitude", "null", 0, true);

      // Enrich the data with additional information, such as unique IDs, simplified wind direction and air quality measurement data
      modifiedData = enrichData(modifiedData);

      // Save the updated data to the REDUX state
      setStationDataFeed(modifiedData);

      // Hide the loading indicator
      setOverlayIsVisible(false);
    })
    .catch( (evt) => {
      // Hide the loading indicator
      setOverlayIsVisible(false);

      setAlertMessage(`There has been a problem retrieving the station feed data. Please try again later. Message: ${evt.message}`);

      // Set the App back to the static data file
      setReloadStaticData(true)
    });
  }

  async function getDataFeed(url) {
    let response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }

  // This component doesn't need to return any markup.
  return (null);
};

DataFeed.propTypes = {
  "url": PropTypes.string,
  "stationDataUrl":  PropTypes.string,
  "setStationDataFeed": PropTypes.oneOfType( [PropTypes.array, PropTypes.func] ),
  "setAlertMessage": PropTypes.oneOfType( [PropTypes.string, PropTypes.func] ),
  "setOverlayIsVisible": PropTypes.oneOfType( [PropTypes.bool, PropTypes.func] ),
  "setReloadStaticData": PropTypes.oneOfType( [PropTypes.bool, PropTypes.func] )
};

const mapStateToProps = (state) => {
  return {
    "stationDataUrl": selectStationDataUrl(state)
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    "setStationDataFeed": stationData => dispatch(setStationData(stationData)),
    "setAlertMessage": message => dispatch(setAlertMessage(message)),
    "setOverlayIsVisible": isVisible => dispatch(setOverlayIsVisible(isVisible)),
    "setReloadStaticData": boolean => dispatch(setReloadStaticData(boolean)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataFeed);
